import { render, staticRenderFns } from "./categoryTable.vue?vue&type=template&id=4cc6ab71&scoped=true"
import script from "./categoryTable.vue?vue&type=script&lang=js"
export * from "./categoryTable.vue?vue&type=script&lang=js"
import style0 from "./categoryTable.vue?vue&type=style&index=0&id=4cc6ab71&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc6ab71",
  null
  
)

export default component.exports